import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import clsx from 'clsx';
import React from 'react';
import { FilterOptionValue, SearchParams } from '@mybestbrands/types';
import styles from './filters.module.scss';
import { useTranslation } from 'next-i18next';

export function CategoriesFilter({
  filter,
  isActive,
  toggleFilterOptions,
  onFilterUpdate,
  onApplySearchFilters,
}: {
  filter: FilterOptionValue | undefined;
  isActive: boolean;
  onFilterUpdate: (value: string[]) => SearchParams | null;
  onApplySearchFilters: (sp?: SearchParams | null) => void;
  toggleFilterOptions: (val: boolean) => void;
}) {
  const { t } = useTranslation('filters');

  const Chevron = isActive ? ChevronUp : ChevronDown;

  if (!filter) return null;

  //Sort options by name
  const options = filter.options.sort((a, b) => {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;

    return 0;
  });

  const selectedCategories = options.filter((option) => option.checked).map((option) => option.value);

  function onCategorySelect(id: string) {
    const newFilterOptions = options.map((option) => {
      return option.id === id ? { ...option, checked: !option.checked } : { ...option, checked: false };
    });

    const selectedCategory = newFilterOptions.filter((option) => option.checked).map((option) => option.value);

    const newSp = onFilterUpdate(selectedCategory);

    onApplySearchFilters(newSp);
  }

  return (
    <div
      key={filter.name}
      className="position-relative"
      style={{
        zIndex: 3,
      }}>
      <div
        onClick={() => toggleFilterOptions(!isActive)}
        key={filter.name}
        className={`btn btn-white-hover-black lowercase d-flex justify-content-center align-items-center ${styles.filter}`}>
        <span className="me-1">{t(filter.name)}</span>
        {!!selectedCategories.length && (
          <span className={clsx(styles.filtercounter)}>
            <span className="position-relative" style={{ bottom: '1px' }}>
              {selectedCategories.length}
            </span>
          </span>
        )}
        <Chevron data-testid="chevron-icon" className={clsx(`ms-2`, isActive ? 'chevron-up' : 'chevron-down')} />
      </div>
      {isActive && (
        <div
          className={`position-absolute bg-white border border-dark ${styles.categoriescontainer} filter-list`}
          style={{ top: '35px', left: 0, width: '14rem', minWidth: '11rem' }}>
          <div className={`d-flex flex-column p-2 ${styles.option} `}>
            {options.map((option) => {
              const name = t(option.name);

              return (
                <div
                  key={option.id}
                  className="d-flex align-items-center mb-2"
                  onClick={() => onCategorySelect(option.id)}>
                  <label
                    className={`${clsx(
                      'cursor-pointer me-3 text-decoration-none text-black',
                      styles.optiionlabel,
                      option.checked ? 'fw-bold' : ''
                    )}`}>
                    <span className={'me-2'}> {name.capitalizeWords()}</span>
                    <span className={styles['filter-badge-gray']}>{option.count}</span>
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
